import { action } from "easy-peasy";
import { IOrganization } from "../interface/organization";
import _ from "lodash";

export const organization: IOrganization = {
  id: "",
  creationTime: 0,
  members: [],
  contracts: [],
  planKey: "",
  invitations: [],
  usedStorage: 0,
  email: "",


  setOrgDetails: action((state, payload) => {
    const checkedMembers = payload.members.map((_member) => {
      if (_member.status === "deleted") {
        return { ..._member, disabled: true };
      }
      return _member;
    });

    state.id = payload.id;
    state.creationTime = payload.creationTime;
    state.members = checkedMembers;
    state.contracts = payload.contracts || [];
    state.invitations = payload.invitations || [];
    state.usedStorage = payload.usedStorage;
    state.email = payload.email;
    state.planKey = payload.planKey;
  }),

  clearOrgDetails: action((state) => {
    state.id = "";
    state.creationTime = 0;
    state.members = [];
    state.contracts = [];
    state.invitations = [];
    state.usedStorage = 0;
    state.email = "";
  }),

  addContract: action((state, payload) => {
    const newContracts = [...state.contracts, payload.contract];
    const newMembers = state.members;
    const member = newMembers.find((_member) => _member.id === payload.userID);
    if (member) {
      member.access.push({ id: payload.contract.contractID, projects: [] });
    }
    state.contracts = newContracts;
    state.members = newMembers;
  }),

  editContractName: action((state, payload) => {
    const newContracts = [...state.contracts];
    const contact = newContracts.find(
      (item) => item.contractID === payload.contractID,
    );
    if (contact) {
      contact.contractName = payload.contractName;
    }
    state.contracts = newContracts;
  }),

  saveMemberRole: action((state, payload) => {
    const newMembers = [...state.members];
    const change = newMembers.find((item) => item.id === payload.memberID);
    if (change) {
      change.role = payload.role;
    }
    state.members = newMembers;
  }),

  addInvitation: action((state, payload) => {
    const newInvitations = [...state.invitations, payload];
    state.invitations = newInvitations;
  }),

  removeInvitation: action((state, payload) => {
    const newInvitations = state.invitations.filter(
      (item) => item.id !== payload,
    );
    state.invitations = newInvitations;
  }),

  removeUser: action((state, payload) => {
    const members = state.members.filter((item) => item.id !== payload);
    state.members = members;
  }),
  setEmail: action((state, payload) => {
    state.email = payload;
  }),

  updateUserAccess: action((state, payload) => {
    const updatedMembers = [...state.members];
    payload.forEach((_change) => {
      const user = updatedMembers.find((_member) => _member.id === _change.id);
      if (user) {
        user.access = _change.access;
      }
    });
    state.members = updatedMembers;
  }),

  updateProjectNameInContract: action((state, payload) => {
    const updatedContracts = [...state.contracts];
    const contract = updatedContracts.find(
      (_contract) => _contract.contractID === payload.contractID,
    );
    if (contract && contract.projects) {
      const project = contract.projects.find(
        (_project) => _project.projectID === payload.projectID,
      );
      if (project) {
        project.projectName = payload.projectName;
      }
    }
    state.contracts = updatedContracts;
  }),

  addProjectToContract: action((state, payload) => {
    const updatedContracts = [...state.contracts];
    const contract = updatedContracts.find(
      (_contract) => _contract.contractID === payload.contractID,
    );
    if (contract) {
      if (!contract.projects) {
        contract.projects = [];
      }
      contract.projects.push(payload.project);
    }
    state.contracts = updatedContracts;
  }),
  removeContract: action((state, payload) => {
    const updatedContracts = state.contracts.filter(
      (_contract) => _contract.contractID !== payload,
    );
    const updatedMembers = state.members.map((_member) => {
      const updatedAccess = _member.access.filter(
        (_access) => _access.id !== payload,
      );
      return {
        ..._member,
        access: updatedAccess,
      };
    });
    state.members = updatedMembers;
    state.contracts = updatedContracts;
  }),

  removeProjectFromOrganization: action((state, payload) => {
    const updatedContracts = [...state.contracts];
    const updatedMembers = [...state.members];
    updatedContracts.forEach((_contract) => {
      if (_contract.projects && _contract.projects.length > 0) {
        _contract.projects = _contract.projects.filter(
          (_project) => _project.projectID !== payload.projectID,
        );
      }
    });
    updatedMembers.forEach((_member) => {
      const accessToRemove: string[] = [];

      _member.access.forEach((_access) => {
        if (_access.projects && _access.projects.length > 0) {
          _access.projects = _access.projects.filter(
            (_projectID) => _projectID !== payload.projectID,
          );
          if (_access.projects.length === 0) {
            accessToRemove.push(_access.id);
          }
        }
        _member.access = _member.access.filter(
          (_access) => !accessToRemove.includes(_access.id),
        );
      });
    });
    state.members = updatedMembers;

    state.contracts = updatedContracts;
  }),
};
